import React, { Component } from 'react';
import FigmaButton from '../../../../Elements/FigmaButton';
import OverWindow from '../../../../Elements/TabList/OverWindow';
import ProjectSearchParams from '../../Project/ProjectSearchParams';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonFooterContainer from '../../../../Elements/ButtonFooterContainer';
import TpProjectChangeItem from '../../../../Domain/TpProjectChangeItem';
import TpPrepaymentProjectChangeItem from '../../../../Domain/TpPrepaymentProjectChangeItem';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';
import NewProjectService from '../../../../Services/NewProjectService';

export default class ChangeTpProjectPanel extends Component {
  static defaultProps = {
    baseItem: {},
    clickOnCancel: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      saving: false,
      searchItem: new ProjectSearchParams(),
    };
    
    this.state.searchItem.ClientIdOrName = props.baseItem.ClientId;
    this.state.searchItem.OfficeName = '';

    TpProjectChangeItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.CfId === item.CfId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });

    const item = new TpPrepaymentProjectChangeItem();
    item.ProjectId = this.state.itemList.find((f) => f.Selected).CfId;
    item.LineItemId = this.props.baseItem.LineItemId;
    item.CiCcid = this.props.baseItem.CiCcId;
    TpClientInvoiceLineItemService.ChangeProjectOfPrepayment(item)
      .then(() => {
        ErrorMessage.SetNotification('New Project Associated with Line Item.');
        window.setTimeout(() => window.location.reload(), 750);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: CPP42. Project association failed. Please notify IT!');
        this.setState({ saving: false });
      });

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Change Project'
          submit={true}
          iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={() => this.handleOnSubmit()}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        title={'Change Project Of Line Item'}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.clickOnCancel(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        zIndex={1050}
        className='applySurveyPanel top-of-boxFigma'
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>
          <TabOfDataTable
            itemList={this.state.itemList}
            type={TpProjectChangeItem}
            serviceFunction={NewProjectService.GetAllItemBySearching}
            changeOfItemListFunction={(itemList) => this.setState({ itemList })}
            convertDBItemsFunction={NewProjectService.ConvertDBItems}
            showSearchStrip={true}
            singleSearchLinePlaceholder='Search in different ids and names...'
            singleSearchLine={true}
            enableUrlPush={false}
            searchParamsType={ProjectSearchParams}
            clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
            searchItem={this.state.searchItem}
            isFilterDisabled={true}
            isRefreshDisabled={true}
          />
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
